(function () {
  var STORAGE_PREFIX = 'figusen_avatar_';
  var AVATAR_SIZE = 256;

  function getUserId() {
    if (typeof getOrInitUserId === 'function') return getOrInitUserId();
    if (window.__buybackNotificationConfig && window.__buybackNotificationConfig.headerUserId) {
      return window.__buybackNotificationConfig.headerUserId;
    }
    return localStorage.getItem('guest_user_id') || '';
  }

  function storageKey(userId) {
    return STORAGE_PREFIX + userId;
  }

  function getSupabase() {
    if (window.headerSupabaseClient) return window.headerSupabaseClient;
    if (window._supabase_buyback_client) return window._supabase_buyback_client;
    return null;
  }

  function applyAvatar(dataUrl) {
    if (!dataUrl) return;
    document.querySelectorAll('[data-user-avatar]').forEach(function (img) {
      img.src = dataUrl;
      img.removeAttribute('hidden');
      img.width = 24;
      img.height = 24;
      img.style.width = '24px';
      img.style.height = '24px';
      img.style.borderRadius = '50%';
      img.style.objectFit = 'cover';
      img.closest('.account-profile__avatar') && img.closest('.account-profile__avatar').classList.add('has-photo');
      var host = img.closest('account-icon') || img.closest('.header-icon-graphic');
      if (host) {
        host.classList.add('has-photo');
        host.querySelectorAll('.svg-wrapper, shop-user-avatar').forEach(function (el) {
          el.setAttribute('hidden', '');
        });
      }
    });
  }

  function loadLocal(userId) {
    if (!userId) return '';
    try {
      return localStorage.getItem(storageKey(userId)) || '';
    } catch (e) {
      return '';
    }
  }

  function saveLocal(userId, dataUrl) {
    try {
      localStorage.setItem(storageKey(userId), dataUrl);
    } catch (e) {
      console.error('アバターの保存に失敗しました', e);
    }
  }

  async function loadRemote(userId) {
    var db = getSupabase();
    if (!db || !userId) return '';
    try {
      var result = await db.from('user_avatars').select('avatar_data').eq('user_id', userId).maybeSingle();
      if (result && result.data && result.data.avatar_data) return result.data.avatar_data;
    } catch (e) {}
    return '';
  }

  async function saveRemote(userId, dataUrl) {
    var db = getSupabase();
    if (!db || !userId) return;
    try {
      await db.from('user_avatars').upsert({
        user_id: userId,
        avatar_data: dataUrl,
        updated_at: new Date().toISOString()
      }, { onConflict: 'user_id' });
    } catch (e) {}
  }

  function cropToSquareDataUrl(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !file.type || file.type.indexOf('image/') !== 0) {
        reject(new Error('画像ファイルを選んでください'));
        return;
      }
      if (file.size > 8 * 1024 * 1024) {
        reject(new Error('画像は8MB以下にしてください'));
        return;
      }
      var img = new Image();
      var objectUrl = URL.createObjectURL(file);
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = AVATAR_SIZE;
        canvas.height = AVATAR_SIZE;
        var ctx = canvas.getContext('2d');
        var min = Math.min(img.width, img.height);
        var sx = (img.width - min) / 2;
        var sy = (img.height - min) / 2;
        ctx.beginPath();
        ctx.arc(AVATAR_SIZE / 2, AVATAR_SIZE / 2, AVATAR_SIZE / 2, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, sx, sy, min, min, 0, 0, AVATAR_SIZE, AVATAR_SIZE);
        URL.revokeObjectURL(objectUrl);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('画像を読み込めませんでした'));
      };
      img.src = objectUrl;
    });
  }

  async function init() {
    var userId = getUserId();
    if (!userId) return;
    var local = loadLocal(userId);
    if (local) applyAvatar(local);
    var remote = await loadRemote(userId);
    if (remote && remote !== local) {
      saveLocal(userId, remote);
      applyAvatar(remote);
    }
  }

  function retryInit() {
    init();
    setTimeout(init, 400);
    setTimeout(init, 1200);
  }

  async function handleFile(file, statusEl) {
    var userId = getUserId();
    if (!userId) {
      if (statusEl) statusEl.textContent = 'ログインするとアイコンを保存できます。';
      return;
    }
    try {
      if (statusEl) statusEl.textContent = '保存中...';
      var dataUrl = await cropToSquareDataUrl(file);
      saveLocal(userId, dataUrl);
      applyAvatar(dataUrl);
      await saveRemote(userId, dataUrl);
      if (statusEl) statusEl.textContent = 'アイコンを変更しました。';
    } catch (e) {
      if (statusEl) statusEl.textContent = e.message || '変更できませんでした。';
    }
  }

  function bindAccountPage() {
    var input = document.getElementById('account-avatar-file');
    var status = document.getElementById('account-avatar-status');
    if (!input) return;
    document.addEventListener('click', function (event) {
      var picker = event.target.closest('[data-avatar-picker], #account-avatar-btn');
      if (!picker) return;
      event.preventDefault();
      input.click();
    });
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (file) handleFile(file, status);
      input.value = '';
    });
  }

  function bindAccountPanel() {
    var btn = document.getElementById('header-account-btn');
    var panel = document.getElementById('header-account-panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function (event) {
      if (panel.hidden) return;
      if (panel.contains(event.target) || btn.contains(event.target)) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
    var noticeBtn = document.getElementById('header-account-notice-btn');
    var noticeBtnMobile = document.getElementById('header-account-notice-btn-mobile');
    function openNotice() {
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (typeof toggleHeaderNotifications === 'function') toggleHeaderNotifications();
    }
    if (noticeBtn) noticeBtn.addEventListener('click', openNotice);
    if (noticeBtnMobile) noticeBtnMobile.addEventListener('click', openNotice);
  }

  var bound = false;

  window.refreshUserAvatar = init;

  function bindAll() {
    if (bound) return;
    bound = true;
    bindAccountPage();
    bindAccountPanel();
    retryInit();
  }

  document.addEventListener('DOMContentLoaded', bindAll);
  if (document.readyState !== 'loading') bindAll();
})();
